import CreateLockModal from './CreateLockModal'

export default CreateLockModal
